<template>
  <Newsletter :data="data" />
</template>
<script>
import Newsletter from "../Newsletter.vue";
import data from "./data.json";

export default {
  components: {
    Newsletter,
  },
  data() {
    return { data }
  }
}
</script>
